import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MOUSEWHEEL } from '../core'
import './product'

$.fn.FlavorCard = function(cards) {
  let self = this

  if (self.data('flavor-card')) {
    return self.data('flavor-card')
  }

  self.link = self.find('.flavors__link')
  self.name = self.link.attr('href').replace('#', '')

  self.card_clicked = function(e) {
    e.preventDefault()
    cards.card_clicked(self)
  }

  self.initialize_scroll = function() {
    if (!$.mlmi.mobile.isMobile) {
      gsap.from(self.link.get(0), {
        rotate: `+=${Math.round(Math.random() * 90 - 45) * 2}`,
        y: () => `+=${Math.round(Math.random() * 260 + 100) * 2}`,
        scrollTrigger: {
          trigger: cards.get(0),
          start: 'top bottom',
          end: () => `bottom bottom`,
          scrub: 2,
          invalidateOnRefresh: true,
        },
      })
    }
  }

  return function() {
    self.initialize_scroll()
    self.on('click', self.card_clicked)
    self.data('flavor-card', self)
    return self
  }()
}

$.fn.FlavorCards = function() {
  let self = this

  if (self.data('flavor-cards')) {
    return self.data('flavor-cards')
  }

  self.section = self.find('#cards')
  self.cards = self.find('.flavors__item')
  self.links = self.find('.flavors__link')
  self.current_card = undefined

  self.card_clicked = function(card) {
    if (card != self.current_card) {
      let is_transition = false
      if (self.current_card != undefined) {
        is_transition = true
        $('body').removeClass('--product-' + self.current_card.name).addClass('--transition')
        $('.product[aria-hidden="false"]').Product().goodbye()
      }
      self.addClass('--spread')
      self.current_card = card
      self.links.attr('aria-expanded', 'false')
      card.link.attr('aria-expanded', 'true')
      $('body').addClass('--transition --product-' + self.current_card.name)
      if (is_transition) {
        setTimeout(function() {
          self.card_clicked_phase_2()
        }, 360)
      } else {
        let distance = $(window).scrollTop() - self.offset().top,
        scrolling = $('html, body').scrollTo(self.offset().top, 450, 2, 'easeInOutQuart', function() {
          self.card_clicked_phase_2()
        })
        if (distance > 0) {
          $('#cards').css('overflow', 'hidden')
        }
        $('html, body').off(MOUSEWHEEL)
        self.cards.each(function() {
          $(this).css('transition-duration', scrolling[1] + 'ms')
        })
      }
    }
    return false
  }

  self.card_clicked_phase_2 = function() {
    $('body').removeClass('--transition').addClass('--transition-phase-2')
    $('#cards').css('overflow', '')
    if (!$.mlmi.mobile.isMobile) {
      $('.terazzo, .page-section, .footer, .footer-signature').hide()
    }
    self.section.addClass('--fixed')
    let product = $('.products [data-id="' + self.current_card.name + '"]').clone().Product(self)
    if ($.mlmi.mobile.isMobile) {
      $('#cards').append(product)
    } else {
      $('.products').before(product)
    }
    product.display()
    product.initialize_animations()
  }

  self.return_to_cards = function(scroll_action) {
    $('body').removeClass('--transition')
    if (!$.mlmi.mobile.isMobile) {
      $('.terazzo, .page-section, .footer, .footer-signature').css('display', '')
    }
    $('#cards').css('overflow', 'hidden')
    self.section.removeClass('--fixed')
    self.current_card = undefined
    if (!$.mlmi.mobile.isMobile) {
      $('html, body').scrollTop(self.offset().top)
      ScrollTrigger.refresh()
    }
    setTimeout(function() {
      self.removeClass('--spread')
      if (!$.mlmi.mobile.isMobile) {
        if (scroll_action == 'up') {
          $('html, body').scrollTo(window.innerHeight, 350, 2, 'easeInOutQuart')
        } else if (scroll_action == 'down') {
          $('html, body').scrollTo($('#cards + .page-section').offset().top, 350, 2, 'easeInOutQuart')
        }
      }
      setTimeout(function() {
        $('#cards').css('overflow', '')
      }, 800)
    }, 50)
  }

  return function() {
    self.cards.each(function(index, card) {
      self.cards[index] = $(card).FlavorCard(self)
    })
    self.data('flavor-cards', self)
    return self
  }()
}
